<script>
    import DefaultComponent from '../defaultComponent';

    export default {
        ...DefaultComponent,
        props: {
            ...DefaultComponent.props,
            sourcelabel: String,
        },
        computed: {
            ...DefaultComponent.computed,
            showSource() {
                return this.item.source && this.url !== this.item.url;
            },
            contentClass() {
                return this.inSidebar ? 'px-0 pt-0' : '';
            }
        }
    }
</script>

<template>
    <a :href="url" :target="target" class="card newslink is-shadowless">
        <div v-if="item.imageSets && item.imageSets.length && !inSidebar" class="card-image">
            <source-set :imageSets="item.imageSets" />
        </div>
        <div :class="['card-content', contentClass]">
            <p v-show="item.date" :class="['has-text-grey-darker', 'mb-3', textClass]">{{ toDateStr(item.date) }}</p>
            <h3 v-show="item.name" :class="['title', titleClass]">{{ item.name }}</h3>
            <p v-show="item.intro" :class="['has-text-black', textClass]">{{ item.intro }}</p>
            <p v-show="showSource" class="has-text-black is-italic">{{ sourcelabel }}: {{ item.source }}</p>
        </div>
    </a>
</template>
